import * as Sentry from '@sentry/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// Only report from the site a build is for. Production builds are also served
// by E2E tests, PR previews and local copies, which would otherwise alert as
// that environment.
const isOwnSite = window.location.origin === new URL(environment.appUrl).origin;

if (environment.sentry.enabled && isOwnSite) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.httpClientIntegration()
    ],
    tracesSampleRate: 0.1,
    debug: environment.sentry.debug,
    environment: environment.name
  });
}

bootstrapApplication(AppComponent, appConfig).catch((err: unknown) =>
  console.error(err)
);
